import { createSlice } from '@reduxjs/toolkit';
import { updateLocalStorageToken, logOut } from "../../../../../../containers/resources/utils";
import axios from 'axios';

export const validateBooking = createSlice({
  name: 'validateBooking',
  initialState: {
    showModal: null,
    isUpdate: null,
    fetching: false,
    error: "",
  },
  reducers: {
    initialStateValidateBooking(state, action) {
      return {
        showModal: null,
        isUpdate: null,
        fetching: false,
        error: "",
      }
    },
    requesValidateBooking(state, action) {
      return {
        showModal: null,
        isUpdate: null,
        fetching: true,
        error: "",
      }
    },
    fetchValidateBookingSuccess(state, action) {
      return {
        showModal: action.payload,
        isUpdate: action.payload,
        fetching: false,
        error: "",
      }
    },
    fetchValidateBookingError(state, action) {
      return {
        showModal:null,
        isUpdate: null,
        fetching: false,
        error: action.payload.error,
      }
    },
    closeModal: (state) => {
      state.showModal = false; 
    },
  }
})

export const isRateGoingToChangeOnUpdate = (data, reservation_id, booking_id) => dispatch => {
  dispatch(requesValidateBooking());
  axios.post(`/reservation/${reservation_id}/booking/${booking_id}/isRateGoingToChangeOnUpdate`, data)
    .then(json => {
      if (json.data.code === 200) {
        dispatch(fetchValidateBookingSuccess(json.data.data));
      } else if (json.data.code === 202) {
        updateLocalStorageToken(json.data.token);
        dispatch(isRateGoingToChangeOnUpdate(data, reservation_id, booking_id));
      } else if (json.data.code === 498) {
        logOut();
      } else {
        dispatch(fetchValidateBookingError(json.data.data));
      }
    })
};

export const {
  initialStateValidateBooking,
  requesValidateBooking,
  fetchValidateBookingSuccess,
  fetchValidateBookingError,
  closeModal
} = validateBooking.actions;

export default validateBooking.reducer;